import React from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';

const DOMAIN = `${process.env.DOMAIN_URL}${process.env.PATH_PREFIX || ''}`;

const CanonicalURL = () => {
  const router = useRouter();
  const cleanPath = router.asPath.split('#')[0].split('?')[0];
  const canonicalUrl = `${DOMAIN}` + (router.asPath === '/' ? '' : cleanPath);

  return (
    <Head>
      <link rel='canonical' href={canonicalUrl} key='canonical' />
    </Head>
  );
}

export default CanonicalURL;